import {Button} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {CommunicationNode} from '../../../interfaces/CommunicationNodeV2';
import {MapLatLangCoordinates} from '../../common/HazardMap';
import ModalDraggable from '../../common/ModalDraggable';
import BeltNodeItemUpsert from './BeltNodeItemUpsert';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  pk?: number;
  item?: CommunicationNode;
  mode?: 'view' | 'update' | 'ack';
  prefetch?: boolean;
  locationCoordinates?: MapLatLangCoordinates;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onSubmitted?: () => void;
  onPurged?: () => void;
  onOpenHistory?: (
    id: number,
    type: 'beltHistoryReport' | 'beltLocationHistoryReport'
  ) => void;
  onOpen?: () => void;
  onClose?: Function;
}

const BeltNodeItemUpsertButton = <T extends ComponentType = typeof Button>({
  pk,
  mode,
  prefetch,
  locationCoordinates,
  component,
  componentProps,
  children,
  onSubmitted,
  onOpen,
  onClose,
  onOpenHistory
}: Props<T>) => {
  const Component = component ?? Button;
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Component
        {...componentProps}
        onClick={() => {
          setIsOpened(true);
          onOpen?.();
        }}
      >
        {children}
      </Component>

      {isOpened ? (
        <ModalDraggable open={isOpened}>
          <BeltNodeItemUpsert
            pk={pk}
            mode={mode}
            prefetch={prefetch}
            locationCoordinates={locationCoordinates}
            onClose={() => {
              setIsOpened(false);
              onClose?.();
            }}
            onSubmitted={() => {
              onSubmitted?.();
              if (!pk) {
                setIsOpened(false);
                onClose?.();
              }
            }}
            onOpenHistory={onOpenHistory}
          />
        </ModalDraggable>
      ) : null}
    </>
  );
};

export default BeltNodeItemUpsertButton;
